import { render, staticRenderFns } from "./Allbeds.vue?vue&type=template&id=004bff7c&scoped=true"
import script from "./Allbeds.vue?vue&type=script&lang=js"
export * from "./Allbeds.vue?vue&type=script&lang=js"
import style0 from "./Allbeds.vue?vue&type=style&index=0&id=004bff7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004bff7c",
  null
  
)

export default component.exports